import {Timeline, VisuallyHidden} from '@primer/react'
import {SkeletonAvatar, SkeletonBox} from '@primer/react/experimental'

export function ConversationTimelineSkeleton({ref}: {ref?: React.Ref<HTMLDivElement>}) {
  return (
    // tabIndex makes this programmatically focusable so focus can land here while the
    // deferred Timeline is still loading, see `useFocusDeferredTimelineHash`.
    <div ref={ref} tabIndex={-1}>
      <VisuallyHidden>Loading conversation timeline</VisuallyHidden>
      <Timeline aria-hidden clipSidebar={false}>
        <CommitSkeleton />
        <CommitSkeleton />
        <CommitSkeleton />
        <ReviewAssignedSkeleton />
        <ReviewedSkeleton />
        <Timeline.Break />
      </Timeline>
    </div>
  )
}

function CommitSkeleton() {
  return (
    <SharedBaseSkeleton className="flex-justify-between">
      <SkeletonBox height="20px" width="30%" />
      <SkeletonBox height="20px" width="10ch" />
    </SharedBaseSkeleton>
  )
}

function ReviewAssignedSkeleton() {
  return (
    <SharedBaseSkeleton>
      <SkeletonBox height="20px" width="60%" />
    </SharedBaseSkeleton>
  )
}

function ReviewedSkeleton() {
  return (
    <SharedBaseSkeleton className="flex-justify-between">
      <SkeletonBox height="20px" width="45%" />
      <SkeletonBox height="20px" width="15ch" />
    </SharedBaseSkeleton>
  )
}

function SharedBaseSkeleton({children, className}: {children: React.ReactNode; className?: string}) {
  return (
    <Timeline.Item>
      <Timeline.Badge>
        <SkeletonAvatar size={20} />
      </Timeline.Badge>
      <Timeline.Body className={`d-flex flex-items-center flex-row gap-2 width-full ${className ?? ''}`}>
        {children}
      </Timeline.Body>
    </Timeline.Item>
  )
}
